import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import CustomIcon from '../components/CustomIcon.vue'

Vue.use(Vuetify)

export default new Vuetify({
  customVariables: ['../assets/variables.scss'],
  treeShake: true,
  // 自前のSVGファイルを単一コンポーネントで読み込む（propsの値で使い分ける）
  // 「$vuetify.icons.（values内で定義したkey）」で呼び出すことができるようになる
  icons: {
    values: {
      AddIcon: {
        component: CustomIcon,
        props: {
          activeIcon: 'AddIcon'
        }
      },
      CautionIcon: {
        component: CustomIcon,
        props: {
          activeIcon: 'CautionIcon'
        }
      },
      CheckIcon: {
        component: CustomIcon,
        props: {
          activeIcon: 'CheckIcon'
        }
      },
      DirectoryPlusIcon: {
        component: CustomIcon,
        props: {
          activeIcon: 'DirectoryPlusIcon'
        }
      },
      DirectoryMinusIcon: {
        component: CustomIcon,
        props: {
          activeIcon: 'DirectoryMinusIcon'
        }
      },
      SearchIcon: {
        component: CustomIcon,
        props: {
          activeIcon: 'SearchIcon'
        }
      }
    }
  }
})
